import { render, staticRenderFns } from "./MpChooseAnswer04.vue?vue&type=template&id=09786c08&scoped=true&"
import script from "./MpChooseAnswer04.vue?vue&type=script&lang=js&"
export * from "./MpChooseAnswer04.vue?vue&type=script&lang=js&"
import style1 from "./MpChooseAnswer04.vue?vue&type=style&index=1&id=09786c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09786c08",
  null
  
)

export default component.exports